<template>
  <div class="sales-order-print">
    <div style="width: 210mm; margin: 0mm auto;">
      <el-button class="printBtn" type="primary" @click="printHandle">打印</el-button>
    </div>
    <table id="print" class="print-table">
      <thead>
        <tr>
          <td>
            <!-- 这里给页眉占位 -->
            <header class="print-header">
              <img class="company-logo" :src="$tenant.stepIcon">
              <div class="company-standad">GK202506</div>
            </header>
          </td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <div class="print-area">
              <div class="printItem">
                <!-- 协议标题 -->
                <div class="title">新时达工控技术(杭州)有限公司销售订单</div>
                <!-- 供需双方基本信息 -->
                <section class="order-content">
                  <div class="basic-info">
                    <h3 class="font-bold">供需双方基本信息</h3>
                    <div class="info-table">
                      <div class="info-row">
                        <div class="info-col">
                          <span class="label">需方：</span>
                          <span class="display-value">{{order.customerName}}</span><input v-model="order.customerName" placeholder="请输入需方名称" class="editable-input">
                        </div>
                        <div class="info-col">
                          <span class="label">供方：</span>
                          <span class="display-value">{{order.belongToCustomerNo}}</span><input v-model="order.belongToCustomerNo" placeholder="请输入供方信息" class="editable-input">
                        </div>
                      </div>
                      <div class="info-row">
                        <div class="info-col">
                          <span class="label">合同编号：</span>
                          <span class="display-value">{{order.customerContractNo}}</span><input v-model="order.customerContractNo" placeholder="请输入合同编号" class="editable-input">
                        </div>
                        <div class="info-col">
                          <span class="label">订单类型：</span>
                          <span class="display-value">{{order.orderType}}</span><input v-model="order.orderType" placeholder="请输入订单类型" class="editable-input">
                        </div>
                      </div>
                      <div class="info-row">
                        <div class="info-col">
                          <span class="label">订单编号：</span>
                          <span class="display-value">{{order.clientContractNo}}</span><input v-model="order.clientContractNo" placeholder="请输入订单编号" class="editable-input">
                        </div>
                        <div class="info-col">
                          <span class="label">订货日期：</span>
                          <span class="display-value">{{order.createTime}}</span><input v-model="order.createTime" placeholder="请输入订货日期" class="editable-input">
                        </div>
                      </div>
                      <div class="info-row">
                        <div class="info-col">
                          <span class="label">联系人：</span>
                          <span class="display-value">{{order.customerContact}}</span><input v-model="order.customerContact" placeholder="请输入需方联系人" class="editable-input">
                        </div>
                        <div class="info-col">
                          <span class="label">经办人：</span>
                          <span class="display-value">{{order.salesPersonName}}</span><input v-model="order.salesPersonName" placeholder="请输入供方经办人" class="editable-input">
                        </div>
                      </div>
                      <div class="info-row">
                        <div class="info-col">
                          <span class="label">电 话：</span>
                          <span class="display-value">{{order.customerPhone}}</span><input v-model="order.customerPhone" placeholder="请输入需方电话" class="editable-input">
                        </div>
                        <div class="info-col">
                          <span class="label">电 话：</span>
                          <span class="display-value">{{order.salesPersonPhone}}</span><input v-model="order.salesPersonPhone" placeholder="请输入供方电话" class="editable-input">
                        </div>
                      </div>
                      <div class="info-row">
                        <div class="info-col">
                          <span class="label">付款方式：</span>
                          <span class="display-value">{{order.paymentDays}}</span><input v-model="order.paymentDays" placeholder="请输入付款方式" class="editable-input">
                        </div>
                        <div class="info-col">
                          <span class="label">运输方式：</span>
                          <span class="display-value">{{order.deliveryMethod}}</span><input v-model="order.deliveryMethod" placeholder="请输入交货日期" class="editable-input">
                        </div>
                      </div>
                    </div>
                  </div>
          
                  <!-- 终端客户信息 -->
                  <div class="client-info">
                    <span class="font-bold">终端客户信息报备</span>
                    <div class="info-row">
                      <div class="info-col full"/>
                    </div>
                    <div class="info-row" style="border: 1px solid #666; border-top: none;">
                      <div class="info-col">
                        <span class="label">终端客户名称：</span>
                        <span class="display-value value">{{order.finalCustomerName}}</span><input v-model="order.finalCustomerName" placeholder="请输入终端客户名称" class="editable-input">
                      </div>
                      <div class="info-col">
                        <span class="label">终端客户订单号：</span>
                        <span class="display-value value">{{order.finalCustomerNo}}</span><input v-model="order.finalCustomerNo" placeholder="请输入终端客户订单号" class="editable-input">
                      </div>
                    </div>
                  </div>
          
                  <!-- 收货信息 -->
                  <div class="delivery-info">
                    <div class="info-row">
                      <span class="label font-bold">收货信息：</span>
                    </div>
                    <div style="border: 1px solid #000; border-top: none;">
                      <div class="info-row">
                        <div class="info-col">
                          <span class="label">收货联系人：</span>
                          <span class="display-value value">{{order.customerDeliveryContact}}</span><input v-model="order.customerDeliveryContact" placeholder="请输入收货联系人" class="editable-input">
                        </div>
                        <div class="info-col">
                          <span class="label">联系电话：</span>
                          <span class="display-value value">{{order.customerDeliveryPhone}}</span><input v-model="order.customerDeliveryPhone" placeholder="请输入联系电话" class="editable-input">
                        </div>
                      </div>
                      <div class="info-row">
                        <div class="info-col full">
                          <span class="label">收货地址：</span>
                          <span class="display-value value">{{order.customerAddress}}</span><input v-model="order.customerAddress" style="width: 100%;" placeholder="请输入收货地址" class="editable-input">
                        </div>
                      </div>
                    </div>
                  </div>
          
                  <!-- 产品清单 -->
                  <div class="product-list">
                    <h3 class="font-bold">所购产品规格型号、数量、价格如下：</h3>
                    <table class="product-table">
                      <thead>
                        <tr>
                          <th width="40">序号</th>
                          <th width="140">物料名称</th>
                          <th width="70">规格型号</th>
                          <th width="40">单位</th>
                          <th width="40">数量</th>
                          <th width="70">单价<br>(含税/元)</th>
                          <th width="70">总金额<br>(含税.元)</th>
                          <th width="100">备注</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in order.materialList" :key="index">
                          <td>{{index + 1}}</td>
                          <td>
                            <span class="display-value">{{item.sapProductName}}</span>
                            <input v-model="item.sapProductName" placeholder="物料名称" class="table-input editable-input">
                          </td>
                          <td>
                            <span class="display-value">{{item.manufacturerModel}}</span>
                            <input v-model="item.manufacturerModel" placeholder="规格型号" class="table-input editable-input">
                          </td>
                          <td>
                            <span class="display-value">{{item.unit}}</span>
                            <input v-model="item.unit" placeholder="单位" class="table-input editable-input">
                          </td>
                          <td>
                            <span class="display-value">{{item.quantity}}</span>
                            <input
                                v-model="item.quantity"
                                placeholder="数量"
                                type="number"
                                class="table-input editable-input"
                                @input="calculateItemTotal(index)">
                          </td>
                          <td>
                            <span class="display-value">¥{{item.unitPrice}}</span>
                            <input
                                v-model="item.unitPrice"
                                placeholder="单价"
                                type="number"
                                class="table-input editable-input"
                                @input="calculateItemTotal(index)">
                          </td>
                          <td>¥{{getItemTotal(item)}}</td>
                          <td>
                            <span class="display-value">{{item.note}}</span>
                            <input v-model="item.note" placeholder="备注" class="table-input editable-input">
                          </td>
                        </tr>
                        <tr>
                          <td colspan="5"><span class="font-bold">总金额（元）大写：</span>{{materialItemsTotalPriceUpper}}</td>
                          <td/>
                          <td class="amount-total">
                            ¥{{materialItemsTotalPrice}}
                          </td>
                          <td/>
                        </tr>
                      </tbody>
                    </table>
                  </div>
          
                  <!-- 备注信息 -->
                  <div class="notes">
                    <h3>注：</h3>
                    <div class="note-list">
                      <div>1. 供方按供货单交货，需方不得以任何借口拒收或延期收货，因需方拒收或延期收货造成的供方损失由需方承担。</div>
                      <div>2. 请需方核对收到的货物是否与下列清单完全相符。</div>
                      <div>3. 如需方发现货物与清单不符或存在质量问题，请在收货之日起 7 日内向供方提出书面异议。</div>
                    </div>
                  </div>
          
                  <!-- 签字确认区 -->
                  <div class="signature-area">
                    <div class="signature-item">
                      <span class="label font-bold">需方单位签章：</span>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import toChineseRMB from "@/util/toChineseRMB.js";
  export default {
    name: "SalesOrderPrint",
    data() {
      return {
        order: {
          customerName: "",
          belongToCustomerNo: "",
          customerNo: "",
          createTime: "",
          customerContact: "",
          customerPhone: "",
          salesPersonName: "",
          salesPersonPhone: "",
          paymentDays: "",
          expirationDate: "",
          finalCustomerName: "",
          finalCustomerNo: "",
          deliveryMessage: "",
          orderType: "销售订单",
          deliveryMethod: "销售订单",
          materialList: [
            {
              materialName: "",
              specification: "",
              unit: "",
              quantity: 0,
              unitPrice: 0,
              note: "",
            },
          ],
          totalAmount: 0,
        },
      };
    },
    computed: {
      // 合同明细总价
      materialItemsTotalPrice() {
        const materialList = (this.order && Array.isArray(this.order.materialList)) ? this.order.materialList : [];
        const total = materialList.reduce((sum, item) => sum + Number(item.unitPrice * item.quantity || 0), 0);
        const valid = Number.isFinite(total) ? total : 0;
        return valid.toLocaleString("zh-CN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      },
      // 合同明细总价大写
      materialItemsTotalPriceUpper() {
        const materialList = (this.order && Array.isArray(this.order.materialList)) ? this.order.materialList : [];
        const total = materialList.reduce((sum, item) => sum + Number(item.unitPrice * item.quantity || 0), 0);
        return toChineseRMB(total);
      },
    },
    mounted() {
      // 如通过 URL 传入 ids，可在此处读取并请求后端数据
      const id = this.$route && this.$route.query && this.$route.query.id;
      if (id) {
        this.fetchData(id);
      }
    },
    methods: {
      fetchData(id) {
        // 示例：根据后端接口调整
        this.$http.get("basic", `clientContracts/${id}`).then((res) => {
          if (res && res.success) {
            Object.assign(this.order, res.data || {});
            this.order.orderType = "销售订单";
            this.order.deliveryMethod = "物流运输";
          }
        }).catch(() => {});
      },
      getItemTotal(item) {
        const quantity = Number(item.quantity || 0);
        const unitPrice = Number(item.unitPrice || 0);
        const total = quantity * unitPrice;
        return total.toLocaleString("zh-CN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      },
      calculateItemTotal() {
        // 触发重新计算总价
        this.$forceUpdate();
      },
      printHandle() {
        window.print();
      },
    },
  };
</script>

<style lang="scss" scoped>
  .print-table {
    width: 210mm;
    margin: 0 auto;
    border-collapse: collapse;
    border: 1px solid #000;
    font-family: 'SimSun', '宋体', serif;
    font-size: 11pt;
    line-height:1.4;
    color: #000;
    background-color: #f0f0f0;
  }
.print-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: transparent;
  /* 屏幕展示保持相对布局（非打印时） */
  line-height: 1.8cm;
  padding: 1.5cm 1.5cm 0;
}
.company-logo { width: 80px; }
.company-standad{
  color: #999;
  font-size: 10pt;
  font-weight: 500;
}
.font-bold{
  font-weight: bold;
}

.delivery-info{
  padding-top: 10px;
}
.printItem {
  padding: 0 1.5cm 1.5cm;
  .title {
    font-size: 18pt;
    font-weight: bold;
    text-align: center;
    margin: 20px 0;
  }
}

.basic-info h3,
.product-list h3,
.notes h3 {
  margin: 10px 0;
  font-size: 11pt;
  color: #000;
}

.info-table {
  border: 1px solid #000;
  border-collapse: collapse;
  margin-bottom: 10px;
}

.info-row {
  display: flex;
  border-bottom: 1px solid #000;
}

.info-row:last-child {
  border-bottom: none;
}

.info-col {
  display: flex;
  flex: 1;
  border-right: 1px solid #000;
  padding: 5px;
}

.info-col:last-child {
  border-right: none;
}

.info-col.full {
  flex: 100%;
}

.info-col .label {
  color: #000;
  margin-right: 5px;
  min-width: 100px;
}

.info-col .value {
  flex: 1;
}

.product-table {
  width: 100%;
  border: 1px solid #000;
  border-collapse: collapse;
  text-align: center;
  box-sizing: border-box;
}

.product-table th,
.product-table td {
  border: 1px solid #000;
  padding: 8px 5px;
}

.product-table th {
  color: #000;
  font-weight: 500;
}

.amount-total {
  color: #000;
  padding-left: 10px;
}

.note-list {
  margin: 10px 0 0 20px;
  padding-left: 0;
}

.note-list li {
  margin-bottom: 5px;
  font-size: 14px;
}

.signature-item {
  display: flex;
  align-items: flex-end;
  height: 50px;
}

.signature-item .label {
  color: #000;
  margin-right: 20px;
}

.signature-line {
  width: 200px;
  height: 1px;
  background-color: #000;
  margin-bottom: 5px;
}
/* 隐藏显示标签，在打印时显示纯文本 */
  .display-value {
    display: none;
  }
  
  /* 打印时隐藏输入框边框，显示为普通文本 */
  .editable-input {
    border: none;
    background: transparent;
    box-shadow: none;
    padding: 0;
    width: auto;
    display: inline;
    font-family: inherit;
    font-size: inherit;
    border-bottom: 2px solid #333;
    &:focus{
      outline: none;
    }
  }
  
  /* 打印时表格输入框样式 */
  .table-input {
    border: none;
    background: transparent;
    box-shadow: none;
    padding: 0;
    width: 100%;
    text-align: center;
    font-family: inherit;
    font-size: inherit;
  }
  

/* 打印专用规则 */
@media print {
  .printBtn,.editable-input {
    display: none;
  }
  .display-value{
    display: initial !important;
  }
   .print-table{
    font-size: 11pt;
  }
  .printItem{
    .title{
      font-size: 18pt;
    }
  }
  .company-standad{
    font-size: 10pt;
  }
  .basic-info h3,
  .product-list h3,
  .notes h3 {
    font-size: 11pt;
  }
  .print-header{
    padding: 0;
  }
  .print-area, .printItem {
    border: none;
    padding: 0 1px;
  }
  .print-table{
    border:none;
    background-color: #fff;
  }
  
  
  /* 实现打印页码功能 */
  @page {
    margin: 0.5cm 1.5cm 1.5cm; /* 底部边距要足够大以容纳页脚 */
    counter-increment: page;
    @bottom-center{
      font-size: 10pt;
      color: #000;
      content: "第 " counter(page) " 页 共 " counter(pages) " 页";
    }
  }
}
</style>